import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import './PreviewCard.sass';
import {AnimationPreview} from '~/common/fabric/Card/components/AnimationPreview/AnimationPreview';
import {
  GiftCardBar,
  GiftCardButton,
} from '~/common/fabric/GiftCard/components/GiftCardButton/GiftCardButton';
import {isAllowedVideoFormat} from '~/common/fabric/utils';
import {Video} from '~library/atoms/Video';

export const PreviewCard = ({
  fabricArt,
  background,
  backgroundColor,
  selectedGuest,
  message,
  userName,
  onPreviewBack,
  isMobile,
  hidePreviewContactInfo = false,
  previewPanelClassName = '',
  initCardFlipped = true,
  hasGiftCard = false,
}) => {
  const media = isMobile ? background?.media[2].url : background?.media[1].url;
  const isVideo = media ? isAllowedVideoFormat(media) : false;
  let style;
  if (!isVideo)
    style = background?.id
      ? {
          backgroundColor,
          backgroundImage: `url(${media})`,
          backgroundSize: 'cover',
        }
      : {
          backgroundColor,
        };
  return (
    <div className="preview-panel__container">
      <div className="preview-panel__wrapper">
        <div className={`preview-panel ${previewPanelClassName}`} id="preview-panel" style={style}>
          {isVideo && <Video src={media} className="preview-panel__background" />}
          <div className="preview-panel__preview-banner create-flow">
            <Typography
              variant="paragraph3"
              color="charcoal"
              classNames="preview-panel__preview-banner-text"
            >
              {!selectedGuest ? (
                'This is a preview of your eCard.'
              ) : (
                <>
                  Previewing <b>{selectedGuest.name}&apos;s</b> eCard
                </>
              )}
            </Typography>
            {isMobile && (
              <Button
                type="button"
                variant="transparent"
                onClick={onPreviewBack}
                data-qa-id="donePreviewBtn"
                className="preview-panel__preview-banner__button"
              >
                Done
              </Button>
            )}
          </div>
          <AnimationPreview
            message={message}
            fabricArt={fabricArt}
            initCardFlipped={initCardFlipped}
            recipientName={selectedGuest?.name}
          />
          {!hidePreviewContactInfo && (
            <div id="preview-content" className="preview-panel__content">
              <div className="preview-panel__content__card">
                <Typography
                  variant="label2"
                  color="pebble"
                  data-qa-id="sent-to"
                  classNames="preview-panel__content__card__label"
                >
                  sent to
                </Typography>
                <Typography
                  variant="paragraph1"
                  color="charcoal"
                  classNames="preview-panel__content__card__name"
                >
                  {selectedGuest?.name || `Recipient’s name`}
                </Typography>
              </div>
              <div className="preview-panel__content__card">
                <Typography variant="label2" color="pebble" data-qa-id="from">
                  from
                </Typography>
                <Typography
                  variant="paragraph1"
                  color="charcoal"
                  classNames="preview-panel__content__card__name"
                >
                  {userName}
                </Typography>
              </div>
            </div>
          )}
        </div>
        {!isMobile && hasGiftCard && (
          <GiftCardBar>
            <GiftCardButton text="Open my gift" disabled />
          </GiftCardBar>
        )}
      </div>
    </div>
  );
};
